<template>
    <LoadingComponent v-if="loadingPage" />
    <div v-else class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex justify-content-center align-items-center">
                <div class="col-md-6"><h6>Contratos Generales</h6></div>
                <div class="col-md-6 text-end">
                  <router-link
                    :to="{ name: 'crear-contrato-general' }"
                    class="btn bg-gradient-primary btn-xs"
                    ><i class="ri-add-line me-1"></i>
                    Nuevo contrato
                  </router-link>
                </div>
              </div>
            </div>
            <div class="card-body px-0 pt-0 pb-2 vh-50">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th></th>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Cliente
                      </th>
                      <th
                        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Importe
                      </th>
                      <th
                        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Plazo
                      </th>
                      <th
                        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Renta Mensual
                      </th>
                      <th class="text-center text-secondary opacity-7"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in contratosGeneral" :key="row.id">
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div
                            class="icon icon-shape icon-sm me-3 bg-gradient-info shadow text-center"
                          >
                            <i class="ri-file-line text-white opacity-10"></i>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle">
                        <div class="d-flex px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-xs text-uppercase">
                              {{ row.nombre_cliente }}
                            </h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="text-center px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-xs text-uppercase">
                              ${{ row.importe }}
                            </h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="text-center px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <p class="mb-0 text-xs text-capitalize">
                              {{ row.plazo }}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="text-center px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <p class="text-xs text-secondary mb-0">
                              {{ row.renta_mensual }}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle text-center">
                        <a
                          :href="urlDownload(row.id, 'general')"
                          class="btn btn-link text-xs text-secondary p-0 m-0"
                        >
                          <i class="ri-download-line me-1"></i>
                          Descargar
                        </a>
                        |
                        <a
                          :href="urlDownload(row.id, 'general/pagare')"
                          class="btn btn-link text-xs text-secondary p-0 m-0"
                        >
                          <i class="ri-download-line me-1"></i>
                          Pagaré
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import LoadingComponent from "@/components/LoadingComponent";
  import { useGeneralStore } from "@/store/general";
  import useContratosStore from "@/store/contratos";
  import { storeToRefs } from "pinia";
  
  export default {
    name: "Contrato-General",
    components: {
      LoadingComponent,
    },
    setup() {
      const storeContratos = useContratosStore();
  
      const {
        fetchContratosGeneral,
        truncateString,
        urlDownload,
      } = storeContratos;
  
      const { contratosGeneral, loadingPage } = storeToRefs(storeContratos);
  
      fetchContratosGeneral();
  
      return {
        contratosGeneral,
        fetchContratosGeneral,
        truncateString,
        urlDownload,
        useGeneralStore,
        loadingPage,
      };
    },
  };
  </script>
  
  <style></style>
  